import { Link, useLocation } from 'react-router-dom';
import { UserMenu } from '@/auth/user-menu';
import { C } from './whoop-theme';

/** Fixed header height — the WHOOP workspace subtracts it from the viewport. */
export const WORKSPACE_HEADER_HEIGHT = 58;

const NAV_LINKS: { label: string; to?: string }[] = [
  { label: 'About', to: '/about' },
  { label: 'Blog' },
  { label: 'Projects' },
  { label: 'Recipes', to: '/recipes' },
  { label: 'Integrations', to: '/integrations' },
];

/**
 * The dark global header (a port of the mockup's header), rendered by the root
 * layout on every page. Sections without a route yet are inert labels. The
 * account control reuses the shared UserMenu, so Google sign-in, sign-out, and
 * the Settings link work everywhere — the design's static "D" chip was only a
 * mock.
 */
export function WorkspaceHeader() {
  const { pathname } = useLocation();

  return (
    <header
      style={{
        height: WORKSPACE_HEADER_HEIGHT,
        flex: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 26px',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        background: 'rgba(12,12,14,0.82)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}
    >
      <Link
        to="/about"
        style={{
          fontSize: 16,
          fontWeight: 700,
          letterSpacing: '-0.01em',
          cursor: 'pointer',
          color: C.text,
        }}
      >
        Dalton Lott
      </Link>

      <div style={{ display: 'flex', alignItems: 'center', gap: 26 }}>
        <nav style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
          {NAV_LINKS.map((link) => {
            const isActive = link.to !== undefined && pathname.startsWith(link.to);
            const style = {
              fontSize: '13.5px',
              fontWeight: isActive ? 700 : 500,
              color: isActive ? C.text : C.text2,
              cursor: 'pointer',
              letterSpacing: '-0.005em',
            } as const;
            return link.to ? (
              <Link key={link.label} to={link.to} className="ww-navlink" style={style}>
                {link.label}
              </Link>
            ) : (
              <span key={link.label} className="ww-navlink" style={style}>
                {link.label}
              </span>
            );
          })}
        </nav>
        <UserMenu />
      </div>
    </header>
  );
}
